import { TEXTS } from '../../constants';
import { textsApi } from '../../state/query/texts';
import store from '../../state/store';
export var getText = function getText(key) {
  var _textsApi$endpoints$g = textsApi.endpoints.getTexts.select({
      lang: store.getState().app.language
    })(store.getState()),
    data = _textsApi$endpoints$g.data;
  return data && data[key] || TEXTS[key];
};